module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Asteriasoft Studio","short_name":"Asteriasoft","start_url":"/","background_color":"#262626","theme_color":"#f2f2f2","display":"standalone","icon":"src/images/logo/favicon.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"7087e28cd12c7ffeb29ffe6f5db67b83"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
